import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["src"]

import { Feedback } from '@/models/feedback.model';
import { Mutations, ShiftCMSState } from '@/store';
import { FeedbackActions, FeedbackState } from '@/stores/feedback.store';
import { UsersActions } from '@/stores/users.store';
import { markRaw, PropType, ref } from 'vue';
import { useStore } from 'vuex';
import UserInfo from '../users/UserInfo.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FeedbackForm',
  props: {
  data: {
    type: Object as PropType<Feedback>,
    required: true,
  },
},
  setup(__props) {

const store = useStore<ShiftCMSState & { fs: FeedbackState }>();

const props = __props;

const getSource = (m: Feedback) => {
  return m.file ? `/file/${m.file.uuid}/original.webp` : '';
};

const removeFeedback = async (d: Feedback) => {
  store.dispatch(FeedbackActions.DeleteFeedback, d.id);
  store.commit(Mutations.HideDrawer);
};

const resolveFeedback = async (d: Feedback) => {
  store.dispatch(FeedbackActions.ResolveFeedback, d.id);
  store.commit(Mutations.HideDrawer);
};

const internalReply = ref<string>(props.data.internalReply);

function saveReply() {
  store.dispatch(FeedbackActions.UpdateFeedback, {
    ...props.data,
    internalReply: internalReply.value,
  });
  store.commit(Mutations.HideDrawer);
}

async function seeUser(user: { name: string; userId: number }) {
  const u = await store.dispatch(UsersActions.GetUser, user.userId);

  store.commit(Mutations.ShowSubDrawer, {
    component: markRaw(UserInfo),
    data: u,
    small: true,
  });
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_center = _resolveComponent("center")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createElementVNode("h2", null, [
        _createTextVNode(" Feedback from " + _toDisplayString(__props.data.user.name) + " ", 1),
        _createVNode(_component_v_btn, {
          type: "button",
          color: "info",
          class: "mr-4",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (seeUser(__props.data.user)))
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode("See user")
          ])),
          _: 1
        }),
        _createVNode(_component_v_btn, {
          type: "button",
          color: "warning",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (removeFeedback(__props.data)))
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode("Delete")
          ])),
          _: 1
        }),
        (!__props.data.resolved)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              type: "button",
              class: "ml-4",
              color: "info",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (resolveFeedback(__props.data)))
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("Resolve")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
      _createVNode(_component_v_row, { class: "mb-8" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(__props.data.message), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_form, {
                onSubmit: _withModifiers(saveReply, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_textarea, {
                    modelValue: internalReply.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((internalReply).value = $event)),
                    label: "Internal reply",
                    density: "compact",
                    required: ""
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_btn, {
                    type: "submit",
                    color: "primary"
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode("Save")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_center, null, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: getSource(__props.data),
            width: "50%",
            class: "screenshot"
          }, null, 8, _hoisted_1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})